// Helpers for the "Link Existing Account" picker used by the property,
// vehicle and asset liability panels. Ids are compared as strings so a
// numeric id from the API matches a string value from the picker.
export const pickerValue = (arg) =>
  (arg && typeof arg === 'object' && arg.target) ? arg.target.value : arg;

export const sameId = (a, b) =>
  a !== null && a !== undefined && a !== '' &&
  b !== null && b !== undefined && b !== '' &&
  String(a) === String(b);

export const uniqueById = (list) => {
  const seen = new Set();
  return (list || []).filter((item) => {
    if (!item || item.id === null || item.id === undefined) return false;
    const key = String(item.id);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

// Accounts that can be linked to the given record (not already linked to it).
export const linkableAccounts = (list, linkField, recordId) =>
  uniqueById(list).filter((account) => !sameId(account[linkField], recordId));

export const findAccountById = (list, id) =>
  (list || []).find((account) => sameId(account.id, id));
